export interface ViewFieldProps {
  label: string
  data: string | string[] | undefined
  colSpan?: number
}

export const ViewField = ({ label, data, colSpan }: ViewFieldProps) => {
  const displayData =
    data !== undefined && data !== null
      ? Array.isArray(data)
        ? data.join(', ')
        : data
      : ''
  return (
    <div className={colSpan ? `col-span-${colSpan}` : ''}>
      <div className="flex gap-1 text-xs view-wrap">
        <div className="whitespace-nowrap text-accent-900">{label}:</div>
        <div className="flex flex-wrap text-accent-500 font-light">
          {displayData}
        </div>
      </div>
    </div>
  )
}
